module.exports = "https://cdn.hellotech.com/client-assets/thermostats_tablet_bc059337a2de5ed6c1b40cf89860ac83.png";